<div class="filter-rail__panel min-h-0 border-r border-line bg-panel" (pointerleave)="filters.closeFiltersPreview()">
  <div class="filter-rail__header">
    <button
      appUiIconButton
      class="rail-icon-button"
      variant="soft"
      size="md"
      type="button"
      (click)="filters.toggleFiltersPinned()"
      [attr.aria-pressed]="filters.filtersPinned()"
      [attr.aria-label]="filters.filtersPinned() ? 'Soltar filtros' : 'Fixar filtros'"
      [title]="filters.filtersPinned() ? 'Soltar filtros' : 'Fixar filtros'"
    >
      <ng-icon [name]="filters.filtersPinned() ? 'heroChevronLeft' : 'heroFunnel'" size="16" aria-hidden="true" />
      @if (!filters.filtersPinned() && filters.activeFilterCount() > 0) {
        <span appBadge tone="danger" size="xs" class="rail-icon-button__badge">{{ filters.activeFilterCount() }}</span>
      }
    </button>

    <div class="filter-rail__title min-w-0">
      <span appUiLabel class="block uppercase tracking-wide">Filtros</span>
      <span class="block truncate text-sm font-semibold text-ink">Conversas ativas</span>
    </div>
  </div>

  <div class="filter-rail__content min-h-0 overflow-y-auto px-3 pb-4">
    <section class="py-3">
      <div
        appToggleGroup
        layout="segmented"
        [columns]="2"
        ngpToggleGroupType="single"
        aria-label="Escopo das conversas"
        [ngpToggleGroupValue]="[filters.activeScope()]"
        (ngpToggleGroupValueChange)="onScopeChange($event)"
      >
        <button
          appToggleGroupItem
          type="button"
          ngpToggleGroupItemValue="all"
        >
          Todas
        </button>
        <button
          appToggleGroupItem
          type="button"
          ngpToggleGroupItemValue="mine"
        >
          Atribuídos a mim
        </button>
      </div>
    </section>

    <section class="filter-section">
      <div class="filter-unread-toggle">
        <button
          appCheckbox
          type="button"
          [ngpCheckboxChecked]="filters.filterUnread()"
          (ngpCheckboxCheckedChange)="setFilterUnread($event)"
          aria-label="Filtrar conversas não lidas"
        >
          <ng-icon name="heroCheck" size="13" aria-hidden="true" class="opacity-0 transition-opacity group-data-[checked]:opacity-100" />
        </button>
        <span class="filter-unread-toggle__label">Não lidas</span>
        @if (filters.filterUnread()) {
          <span class="filter-unread-toggle__active" aria-label="Filtro ativo"></span>
        }
      </div>
    </section>

    <section class="filter-section">
      <span appUiFilterLabel id="conversation-status-label" class="mb-2 block uppercase">Status</span>
      <div
        appSelect
        aria-labelledby="conversation-status-label"
        [ngpSelectValue]="filters.selectedStatus()"
        (ngpSelectValueChange)="onStatusChange($event)"
        (ngpSelectOpenChange)="filters.setFilterMenuOpen($event)"
      >
        <span class="truncate">{{ filters.selectedStatusLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          <div appSelectOption ngpSelectOptionValue="todas">
            <span>Todos os status</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="open">
            <span>Abertas</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="pending">
            <span>Pendentes</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="agent">
            <span>Com agente</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="snoozed">
            <span>Pausadas</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="resolved">
            <span>Resolvidas</span>
          </div>
        </div>
      </div>
    </section>

    <section class="filter-section">
      <span appUiFilterLabel id="conversation-priority-label" class="mb-2 block uppercase">Prioridade</span>
      <div
        appSelect
        aria-labelledby="conversation-priority-label"
        [ngpSelectValue]="filters.selectedPriority()"
        (ngpSelectValueChange)="onPriorityChange($event)"
        (ngpSelectOpenChange)="filters.setFilterMenuOpen($event)"
      >
        <span class="truncate">{{ filters.selectedPriorityLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          <div appSelectOption ngpSelectOptionValue="todas">
            <span>Todas as prioridades</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="low">
            <span>Baixa</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="normal">
            <span>Normal</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="high">
            <span>Alta</span>
          </div>
          <div appSelectOption ngpSelectOptionValue="urgent">
            <span>Urgente</span>
          </div>
        </div>
      </div>
    </section>

    <section class="filter-section">
      <span appUiFilterLabel id="conversation-team-label" class="mb-2 block uppercase">Equipe</span>
      <div
        appSelect
        aria-labelledby="conversation-team-label"
        [ngpSelectValue]="filters.activeTeam()"
        (ngpSelectValueChange)="onTeamChange($event)"
        (ngpSelectOpenChange)="filters.setFilterMenuOpen($event)"
      >
        <span class="truncate">{{ filters.selectedTeamLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          @for (team of filters.teamFilters(); track team.id) {
            <div appSelectOption [ngpSelectOptionValue]="team.id">
              <span>{{ team.label }}</span>
              <span appUiHint>{{ team.count }}</span>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="filter-section">
      <span appUiFilterLabel class="mb-2 block uppercase">Situação</span>
      <div
        appSelect
        aria-label="Filtrar por situação"
        [ngpSelectValue]="filters.selectedSituation()"
        (ngpSelectValueChange)="onSituationChange($event)"
        (ngpSelectOpenChange)="filters.setFilterMenuOpen($event)"
      >
        <span class="truncate">{{ filters.selectedSituationLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          <div appSelectOption ngpSelectOptionValue="todas">
            <span>Todas as situações</span>
          </div>
          @for (situation of filters.situationFilters(); track situation.id) {
            <div appSelectOption [ngpSelectOptionValue]="situation.id">
              <span>{{ situation.label }}</span>
              <span appUiHint>{{ situation.count }}</span>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="filter-section">
      <div class="flex items-center justify-between gap-3">
        <span appUiFilterLabel class="block uppercase">Tags</span>
        @if (filters.activeFilterCount() > 0) {
          <span appUiLabel class="rounded-md bg-soft px-1.5 py-0.5">{{ filters.activeFilterCount() }}</span>
        }
      </div>

      <div class="mt-3 space-y-1">
        @for (tag of filters.tagFilters(); track tag.id) {
          <div class="tag-filter">
            <button
              appCheckbox
              type="button"
              [ngpCheckboxChecked]="filters.isTagSelected(tag.id)"
              (ngpCheckboxCheckedChange)="setTagSelected(tag.id, $event)"
              [attr.aria-label]="'Filtrar tag ' + tag.label"
            >
              <ng-icon name="heroCheck" size="13" aria-hidden="true" class="opacity-0 transition-opacity group-data-[checked]:opacity-100" />
            </button>
            <span class="truncate">{{ tag.label }}</span>
            <span appUiLabel class="ml-auto">{{ tag.count }}</span>
          </div>
        } @empty {
          <p appUiEmptyText>Nenhuma tag aplicada nas conversas carregadas.</p>
        }
      </div>
    </section>
  </div>
</div>
